/**
 * The appearance toggle.
 *
 * A segmented group rather than a dropdown, matching the language toggle beside
 * it: there are three options, the choice is one an operator makes once, and a
 * segmented control shows which one is active without being opened.
 *
 * Labels come from the active dictionary, unlike the language toggle — that one
 * writes each option in its own language so it stays legible to someone who
 * cannot read the other, and no such argument applies here.
 *
 * The selection is persisted to `localStorage` by the provider, so it survives
 * a reload but stays on this device — it is a reading preference, not workspace
 * configuration, and the app is explicit elsewhere that workspace configuration
 * lives server-side.
 */

import { THEMES, useTheme } from '../../lib/theme';
import { useT } from '../../i18n';

export function ThemeToggle() {
  const t = useT();
  const { theme, setTheme } = useTheme();

  return (
    <div className="lang-toggle" role="group" aria-label={t.shell.themeLabel}>
      {THEMES.map((option) => (
        <button
          key={option}
          type="button"
          className={option === theme ? 'btn btn--sm btn--primary' : 'btn btn--sm btn--subtle'}
          aria-pressed={option === theme}
          onClick={() => setTheme(option)}
        >
          {t.shell.theme[option]}
        </button>
      ))}
    </div>
  );
}
